const routes = [{
    path: '/access/visitorRecord', //预约记录
    name: 'visitorRecord',
    component: () => import('@src/modules/visitorRecord/view/visitorRecord'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    path: '/access/invitation', //预约记录
    name: 'invitation',
    component: () => import('@src/modules/visitorRecord/view/invitation'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    path: '/access/visitorAudit', //预约记录
    name: 'visitorAudit',
    component: () => import('@src/modules/visitorRecord/view/visitorAudit'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },

  {
    path: '/carAuthorizationRecord/index', //授权记录
    name: 'carAuthorizationRecord',
    component: () => import('@src/modules/visitorRecord/view/visitor-car-record'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }, {
    path: '/visitorConfig',
    name: 'visitorConfig',
    component: () => import('@src/modules/visitorRecord/view/visitor-config'),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  }
]

export default routes